import DeviceList from "../../components/dashboard/device/DeviceList";

const Devices = () => <DeviceList />;

export default Devices;
